import * as React from "react";

const KONAMI_CODE = [
  "ArrowUp",
  "ArrowUp",
  "ArrowDown",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "ArrowLeft",
  "ArrowRight",
  "b",
  "a",
];

// Invokes onUnlock once the Konami code is typed.
export const useKonamiCode = (onUnlock: () => void): void => {
  React.useEffect(() => {
    let index = 0;
    const matches = (key: string | undefined, expected: string) =>
      key?.toLowerCase() === expected.toLowerCase();

    const onKeyDown = (e: KeyboardEvent) => {
      if (matches(e.key, KONAMI_CODE[index])) {
        index += 1;
        if (index === KONAMI_CODE.length) {
          index = 0;
          onUnlock();
        }
        return;
      }
      index = matches(e.key, KONAMI_CODE[0]) ? 1 : 0;
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onUnlock]);
};
